var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22335_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4305 23.4787C64.9565 19.933 61.971 16.1051 59.6266 14.8953C61.5346 18.6358 62.639 22.3881 63.0609 25.1885C63.0609 25.1939 63.0631 25.2076 63.0676 25.2449C59.2324 15.686 52.7295 11.8316 47.4193 3.43899C47.1512 3.01463 46.8823 2.58917 46.6204 2.1406C46.4871 1.9116 46.3624 1.67755 46.247 1.43898C46.0263 1.01297 45.8563 0.562762 45.7399 0.0973809C45.7415 0.0517178 45.7082 0.0123435 45.6628 0.00646476C45.642 0.000449248 45.6199 0.000449248 45.5991 0.00646476C45.5943 0.00810535 45.5872 0.0137107 45.5821 0.0156247C45.5746 0.0186325 45.5235 0.0489835 45.5258 0.0462491C37.0059 5.03598 34.1613 14.2305 33.8956 18.8487C30.4935 19.0826 27.2406 20.336 24.5612 22.4457C24.2807 22.2087 23.9874 21.9873 23.6827 21.7823C22.9097 19.0778 22.8767 16.2152 23.5875 13.4936C20.1035 15.0801 17.3935 17.5877 15.4234 19.802H15.4077C14.0632 18.0991 14.1579 12.4814 14.2346 11.3085C14.2185 11.2358 13.2317 11.8208 13.1024 11.909C11.9159 12.7558 10.8068 13.706 9.78782 14.7484C8.62833 15.9242 7.56892 17.1947 6.62065 18.5465C6.62065 18.5482 6.6197 18.5502 6.61915 18.5519C6.61915 18.5501 6.62011 18.5482 6.62065 18.5465C4.43976 21.6371 2.89295 25.1293 2.06979 28.8213C2.05352 28.8948 2.03985 28.971 2.02412 29.0451C1.96028 29.3437 1.73059 30.8374 1.6904 31.162C1.68725 31.187 1.68589 31.211 1.68288 31.236C1.3858 32.7803 1.20191 34.3442 1.13246 35.9154C1.13246 35.9732 1.12891 36.0305 1.12891 36.0886C1.12973 54.818 16.3149 70.0007 35.0458 70.0007C51.8209 70.0007 65.7494 57.8231 68.4762 41.8276C68.5336 41.3936 68.5797 40.9572 68.6303 40.5193C69.3044 34.7034 68.5555 28.5905 66.4305 23.4787ZM27.3392 50.0238C27.4977 50.0995 27.6468 50.1824 27.8097 50.2551C27.8166 50.2597 27.8259 50.2649 27.8327 50.2692C27.6669 50.19 27.5024 50.1081 27.3392 50.0238ZM63.0702 25.2533L63.0657 25.2203C63.0673 25.2324 63.0695 25.2449 63.0713 25.2568L63.0702 25.2533Z",
    fill: "url(#paint0_linear_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4301 23.478C64.956 19.9322 61.9706 16.1043 59.6262 14.8945C61.5342 18.6351 62.6386 22.3874 63.0605 25.1877C63.0605 25.1795 63.062 25.1946 63.0655 25.2196C63.0672 25.2316 63.0694 25.2442 63.0711 25.2561C66.2711 33.9312 64.5278 42.7528 62.0157 48.1433C58.1293 56.484 48.7195 65.032 33.9914 64.615C18.0786 64.1645 4.05983 52.3575 1.44294 36.8931C0.966077 34.4545 1.44294 33.2163 1.68288 31.2362C1.39058 32.7626 1.27929 33.2035 1.13246 35.9156C1.13246 35.9734 1.12891 36.0307 1.12891 36.0888C1.12932 54.8173 16.3145 70 35.0454 70C51.8205 70 65.749 57.8224 68.4758 41.8269C68.5332 41.3928 68.5793 40.9564 68.6299 40.5185C69.304 34.7026 68.5551 28.5898 66.4301 23.478Z",
    fill: "url(#paint1_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4301 23.478C64.956 19.9322 61.9706 16.1043 59.6262 14.8945C61.5342 18.6351 62.6386 22.3874 63.0605 25.1877C63.0605 25.1795 63.062 25.1946 63.0655 25.2196C63.0672 25.2316 63.0694 25.2442 63.0711 25.2561C66.2711 33.9312 64.5278 42.7528 62.0157 48.1433C58.1293 56.484 48.7195 65.032 33.9914 64.615C18.0786 64.1645 4.05983 52.3575 1.44294 36.8931C0.966077 34.4545 1.44294 33.2163 1.68288 31.2362C1.39058 32.7626 1.27929 33.2035 1.13246 35.9156C1.13246 35.9734 1.12891 36.0307 1.12891 36.0888C1.12932 54.8173 16.3145 70 35.0454 70C51.8205 70 65.749 57.8224 68.4758 41.8269C68.5332 41.3928 68.5793 40.9564 68.6299 40.5185C69.304 34.7026 68.5551 28.5898 66.4301 23.478Z",
    fill: "url(#paint2_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9466 27.4641C50.0206 27.516 50.0877 27.5677 50.1573 27.6192C49.3061 26.1085 48.2462 24.7255 47.0087 23.5108C36.466 12.9693 45.5303 0.0437499 45.5328 0.0410156C37.0129 5.03074 34.1602 14.2291 33.8945 18.8471C34.2896 18.8198 34.6838 18.7866 35.0859 18.7866C41.4437 18.7867 46.9813 22.2824 49.9466 27.4641Z",
    fill: "url(#paint3_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1089 29.5695C35.0534 30.4132 32.0727 33.3225 31.0303 33.3225C21.3858 33.3225 19.8203 39.156 19.8203 39.156C20.2476 44.0686 23.6675 48.1141 27.8096 50.2546C27.9985 50.3523 28.1898 50.4404 28.3812 50.5277C28.7093 50.673 29.0415 50.8088 29.3775 50.9349C30.7977 51.4378 32.2853 51.7246 33.7906 51.7861C50.6948 52.579 53.9698 31.5776 41.7706 25.479C44.8947 24.9356 48.1375 26.1921 49.9484 27.4642C46.9831 22.2829 41.4455 18.7871 35.0878 18.7871C34.6856 18.7871 34.2917 18.8203 33.8965 18.8477C30.4943 19.0816 27.2414 20.335 24.562 22.4447C25.0791 22.8822 25.6629 23.467 26.8926 24.6785C29.1933 26.9459 35.0963 29.294 35.1089 29.5695Z",
    fill: "url(#paint4_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1089 29.5695C35.0534 30.4132 32.0727 33.3225 31.0303 33.3225C21.3858 33.3225 19.8203 39.156 19.8203 39.156C20.2476 44.0686 23.6675 48.1141 27.8096 50.2546C27.9985 50.3523 28.1898 50.4404 28.3812 50.5277C28.7093 50.673 29.0415 50.8088 29.3775 50.9349C30.7977 51.4378 32.2853 51.7246 33.7906 51.7861C50.6948 52.579 53.9698 31.5776 41.7706 25.479C44.8947 24.9356 48.1375 26.1921 49.9484 27.4642C46.9831 22.2829 41.4455 18.7871 35.0878 18.7871C34.6856 18.7871 34.2917 18.8203 33.8965 18.8477C30.4943 19.0816 27.2414 20.335 24.562 22.4447C25.0791 22.8822 25.6629 23.467 26.8926 24.6785C29.1933 26.9459 35.0963 29.294 35.1089 29.5695Z",
    fill: "url(#paint5_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9782 21.3172C23.2144 21.4696 23.4487 21.6248 23.6812 21.7828C22.9082 19.0783 22.8752 16.2157 23.586 13.4941C20.1019 15.0806 17.392 17.5882 15.4219 19.8025C15.5848 19.798 20.5044 19.7094 22.9782 21.3172Z",
    fill: "url(#paint6_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44191 36.8928C4.05879 52.3571 18.0775 64.1642 33.9903 64.6148C48.7185 65.0317 58.1282 56.4831 62.0147 48.1431C64.5267 42.7521 66.2702 33.9316 63.0701 25.2559L63.069 25.2522L63.0645 25.2194C63.0609 25.1942 63.0589 25.1793 63.0594 25.1875C63.0594 25.193 63.0616 25.2067 63.0661 25.244C64.2691 33.0993 60.2733 40.7092 54.0269 45.8548L54.0081 45.8989C41.8367 55.8092 30.1896 51.8782 27.8314 50.2691C27.6657 50.1893 27.501 50.1073 27.3374 50.0231C20.2413 46.632 17.3099 40.1671 17.9383 34.6229C11.9465 34.6229 9.9034 29.5693 9.9034 29.5693C9.9034 29.5693 15.283 25.7336 22.3731 29.0696C28.9397 32.1592 35.1067 29.5696 35.1074 29.5693C35.0948 29.2938 29.1919 26.9457 26.8906 24.6784C25.661 23.467 25.0771 22.8829 24.5601 22.4446C24.2795 22.2077 23.9863 21.9862 23.6815 21.7813C23.4488 21.6235 23.2145 21.4683 22.9785 21.3156C20.5049 19.7078 15.5852 19.7964 15.4222 19.8006H15.4065C14.062 18.0977 14.1568 12.48 14.2335 11.307C14.2173 11.2343 13.2305 11.8193 13.1012 11.9075C11.9148 12.7543 10.8056 13.7046 9.78665 14.7469C8.62716 15.923 7.56775 17.1937 6.61948 18.5459C6.61948 18.5475 6.61853 18.5496 6.61798 18.5512C6.61798 18.5494 6.61894 18.5475 6.61948 18.5459C4.43859 21.6365 2.89178 25.1286 2.06862 28.8206C2.05235 28.8939 0.847742 34.1609 1.44191 36.8928Z",
    fill: "url(#paint7_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0105 23.5113C48.2479 24.726 49.3079 26.109 50.1591 27.6198C50.3458 27.76 50.5203 27.8999 50.6682 28.0363C58.3571 35.1208 54.3285 45.1409 54.028 45.8549C60.2744 40.7095 64.2702 33.0995 63.0673 25.2442C59.2321 15.6854 52.7292 11.831 47.419 3.43837C47.1509 3.014 46.882 2.58854 46.6201 2.13998C46.4868 1.91098 46.3621 1.67692 46.2467 1.43835C46.026 1.01234 45.8559 0.562136 45.7396 0.0967543C45.7412 0.0510911 45.7079 0.0117169 45.6625 0.00583812C45.6417 -0.00017739 45.6295 -0.00250156 45.6086 0.00351394C45.6038 0.00515454 45.5869 0.0130841 45.5818 0.0149981C45.5743 0.0180058 45.565 0.0249784 45.557 0.0290799C44.2655 0.693793 36.4677 12.9698 47.0105 23.5113Z",
    fill: "url(#paint8_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6672 28.0366C50.5192 27.9001 50.3447 27.7603 50.1581 27.62C50.0891 27.568 50.0214 27.5164 49.9474 27.4648C48.1365 26.1927 44.8937 24.9363 41.7696 25.4796C53.9688 31.5782 50.6938 52.5796 33.7896 51.7868C32.2843 51.7254 30.7967 51.4384 29.3765 50.9356C29.0405 50.8092 28.7085 50.6735 28.3802 50.5283C28.1888 50.4411 27.9977 50.3529 27.8086 50.2553C27.8154 50.2599 27.8247 50.2651 27.8316 50.2693C30.1898 51.8782 41.8369 55.8095 54.0083 45.8992L54.027 45.8551C54.3275 45.1417 58.356 35.1213 50.6672 28.0366Z",
    fill: "url(#paint9_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8217 39.1566C19.8217 39.1566 21.3873 33.3231 31.0318 33.3231C32.0744 33.3231 35.0552 30.4138 35.1103 29.5701C35.1655 28.7264 28.943 32.16 22.376 29.0704C15.2859 25.7344 9.90625 29.5701 9.90625 29.5701C9.90625 29.5701 11.9493 34.6237 17.9412 34.6237C17.3127 40.1679 20.2442 46.6335 27.3403 50.0239C27.4989 50.0996 27.6479 50.1825 27.8107 50.2552C23.669 48.1147 20.249 44.0692 19.8217 39.1566Z",
    fill: "url(#paint10_radial_22335_1127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4298 23.4781C64.9558 19.9323 61.9703 16.1044 59.6259 14.8946C61.5339 18.6352 62.6383 22.3875 63.0602 25.1878C63.0602 25.1933 63.0624 25.207 63.0669 25.2443C59.2317 15.6854 52.7288 11.831 47.4186 3.43837C47.1505 3.014 46.8816 2.58854 46.6197 2.13998C46.4864 1.91098 46.3617 1.67692 46.2463 1.43835C46.0256 1.01234 45.8556 0.562136 45.7392 0.0967543C45.7409 0.0510911 45.7075 0.0117169 45.6621 0.00583812C45.6413 -0.00017739 45.6292 -0.00250156 45.6083 0.00351394C45.6035 0.00515454 45.5865 0.0130841 45.5815 0.0149981C45.5739 0.0180058 45.5469 0.0334548 45.5437 0.0353688C36.7823 5.2798 34.1606 14.2301 33.895 18.848C34.2901 18.8207 34.6841 18.7875 35.0863 18.7875C41.4444 18.7875 46.982 22.2832 49.9469 27.4646C48.136 26.1924 44.8932 24.936 41.7691 25.4793C53.9683 31.578 50.6933 52.5793 33.7891 51.7865C32.2838 51.7251 30.7962 51.4382 29.376 50.9354C29.04 50.8091 28.708 50.6734 28.3797 50.5282C28.1883 50.4409 27.9972 50.3528 27.8081 50.2552C27.8149 50.2598 27.8242 50.265 27.8311 50.2692C27.6654 50.1895 27.5006 50.1075 27.3371 50.0233C27.4957 50.099 27.6447 50.1819 27.8077 50.2546C23.6656 48.114 20.2455 44.0686 19.8184 39.156C19.8184 39.156 21.3839 33.3225 31.0284 33.3225C32.071 33.3225 35.0519 30.4131 35.107 29.5695C35.0944 29.294 29.1914 26.9459 26.8902 24.6786C25.6606 23.4671 25.0766 22.8831 24.5596 22.4448C24.279 22.2078 23.9858 21.9864 23.681 21.7814C22.9081 19.0769 22.8751 16.2144 23.5859 13.4927C20.1018 15.0792 17.3918 17.5868 15.4218 19.8011H15.406C14.0616 18.0982 14.1563 12.4805 14.233 11.3075C14.2169 11.2347 13.2301 11.8197 13.1007 11.9079C11.9143 12.7547 10.8051 13.7049 9.78618 14.7474C8.6271 15.9234 7.56796 17.1939 6.61997 18.5459C6.61997 18.5475 6.61901 18.5496 6.61847 18.5512C6.61847 18.5495 6.61942 18.5475 6.61997 18.5459C4.43908 21.6365 2.89227 25.1286 2.0691 28.8207C2.05283 28.8942 2.03916 28.9704 2.02344 29.0445C1.95959 29.3431 1.67263 30.8584 1.63257 31.1834C1.63558 31.1585 1.62942 31.2084 1.63257 31.1834C1.37076 32.7492 1.20383 34.3294 1.13246 35.9154C1.13246 35.9732 1.12891 36.0305 1.12891 36.0886C1.12891 54.8172 16.3141 70 35.045 70C51.8201 70 65.7486 57.8224 68.4754 41.8269C68.5328 41.3928 68.5789 40.9564 68.6295 40.5185C69.3037 34.7027 68.5548 28.5899 66.4298 23.4781ZM63.0653 25.2197C63.0669 25.2317 63.0691 25.2443 63.0709 25.2562L63.0698 25.2525L63.0653 25.2197Z",
    fill: "url(#paint11_linear_22335_1127)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22335_1127",
    x1: 60.2143,
    y1: 10.8296,
    x2: 5.75574,
    y2: 63.3811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF0D8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5503 14.8981) scale(69.3672 70.5353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF027B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FF0083"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3192 36.9619) scale(71.1013 70.5353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#AF0611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CE1223",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FD243B",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF304B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3450",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.7 -3.26693) scale(22.767 38.6527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.6756 55.1546) scale(30.1293 33.0221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#008EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF36EA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.92 29.6787) scale(15.9972 19.4812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#80008E",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7668 5.20447) scale(23.9523 24.0374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6353 -10.5603) scale(114.354 95.9937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF0D8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.967 -8.68274) rotate(83.9544) scale(75.1781 75.7408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FF0D8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0125 13.8503) scale(65.6544 64.5011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF0D8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_22335_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0576 17.6186) scale(78.9145 70.5985)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22335_1127",
    x1: 56.8751,
    y1: 11.2291,
    x2: 13.3202,
    y2: 58.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF339",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF339",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22335_1127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.232052d63bfe9675b17c4f1ed78260e5.svg";
export { ForwardRef as ReactComponent };